import {
  IConfigGroupMappingsQueryVariables,
  useConfigGroupMappingsQuery,
} from '../graphql/ConfigGroupMappings'

export const useConfigGroupMappings = ({
  connectionConfigId,
}: IConfigGroupMappingsQueryVariables) => {
  const { data, loading } = useConfigGroupMappingsQuery({
    variables: {
      connectionConfigId,
    },
  })

  return {
    data,
    loading,
  }
}
